import { useEffect, useState } from 'react';

import { useFragmentContext } from '@jsmdg/react-fragment-scripts/fragment';
import { type AddVoucher, CustomUIEventEnum, type RemoveVoucher } from '@jsmdg/ui-event';
import { type ProductDetailContext } from '../types/types';

export const useRedemptionCart = (): {
    isRedemptionCartFilled: boolean;
    isProductInRedemptionCart: boolean;
} => {
    const { product, redemptionInformation } = useFragmentContext<ProductDetailContext>();
    const [isRedemptionCartFilled, setIsRedemptionCartFilled] = useState(false);
    const [isProductInRedemptionCart, setIsProductInRedemptionCart] = useState(false);

    useEffect(() => {
        const handleVoucherUIEvent = (event: CustomEvent<AddVoucher | RemoveVoucher>) => {
            if (redemptionInformation && event.detail.cartProductIds.length) {
                setIsRedemptionCartFilled(true);
                const isCartProduct = event.detail.cartProductIds.includes(product.productId);
                setIsProductInRedemptionCart(isCartProduct);
            }
        };

        document.addEventListener(CustomUIEventEnum.AddVoucher, handleVoucherUIEvent);
        document.addEventListener(CustomUIEventEnum.RemoveVoucher, handleVoucherUIEvent);

        return () => {
            document.removeEventListener(CustomUIEventEnum.AddVoucher, handleVoucherUIEvent);
            document.removeEventListener(CustomUIEventEnum.RemoveVoucher, handleVoucherUIEvent);
        };
    }, [product, redemptionInformation]);

    return { isRedemptionCartFilled, isProductInRedemptionCart };
};
